<breadcrumb [items]="breadcrumb" />
<h1 class="mb-2">Perfil</h1>

<div class="position-absolute top-50 start-50 translate-middle" *ngIf="loading.main">
    <div class="spinner-border" role="status"></div>
</div>

<ul class="nav nav-tabs mx-md-n4 px-md-4" id="profileTab" role="tablist">
    <li class="nav-item" role="presentation">
        <button class="nav-link active" id="profile" data-bs-toggle="tab" data-bs-target="#profile-pane" type="button"
            role="tab">Informações</button>
    </li>
    <li class="nav-item" role="presentation">
        <button class="nav-link" id="password" data-bs-toggle="tab" data-bs-target="#password-pane" type="button"
            role="tab">Alterar Senha</button>
    </li>
</ul>
<div class="tab-content" id="profileTabContent">
    <div class="tab-pane fade show active" id="profile-pane" role="tabpanel" tabindex="0">
        <form class="row mt-3" novalidate (ngSubmit)="saveProfile()" *ngIf="!loading.main">
            <div class="col-12 col-md-6 mb-3">
                <label for="name">Nome</label>
                <input id="name" name="name" type="text" class="form-control" [(ngModel)]="doctor.name" required/>
            </div>
            <div class="col-12 col-md-6 mb-3">
                <label for="email">Email</label>
                <input id="email" name="email" type="email" class="form-control" [(ngModel)]="doctor.email" required/>
            </div>
            <div class="col-12 col-md-6 mb-3">
                <label for="docCrm">CRM</label>
                <input type="text" class="form-control" id="docCrm" name="docCrm" [(ngModel)]="doctor.crm">
            </div>
            <div class="col-12 col-md-6 mb-3">
                <label for="docTelefone">Telefone</label>
                <input type="text" class="form-control" id="docTelefone" name="docTelefone" [(ngModel)]="doctor.phone"
                    mask="(00) 00000-0000">
            </div>
            <div class="col-12 col-md-3 col-lg-2 offset-md-9 offset-lg-10">
                <button type="submit" class="btn btn-success w-100" [disabled]="validateProfileForm()">
                    <div class="spinner-border spinner-border-sm" role="status" *ngIf="loading.save"></div>
                    <span *ngIf="!loading.save">Atualizar</span>
                </button>
            </div>
        </form>
    </div>
    <div class="tab-pane fade" id="password-pane" role="tabpanel" tabindex="0">
        <form class="row mt-3" novalidate (ngSubmit)="updatePassword()" *ngIf="!loading.main">
            <div class="col-12 col-md-6 mb-3">
                <label for="currentPassword">Nova Senha</label>
                <input id="newPassword" name="newPassword" type="password" class="form-control"
                    [(ngModel)]="password.new" />
            </div>
            <div class="col-12 col-md-6 mb-3">
                <label for="currentPassword">Confirmar Nova Senha</label>
                <input id="confirmPassword" name="confirmPassword" type="password" class="form-control"
                    [(ngModel)]="password.confirm" [ngClass]="{'is-invalid': checkPassword()}" />
                <div *ngIf="checkPassword()" class="invalid-feedback">As senhas não conferem</div>
            </div>
            <div class="col-12 col-md-3 col-lg-2 offset-md-9 offset-lg-10">
                <button type="submit" class="btn btn-success w-100" [disabled]="validatePasswordForm()">
                    <div class="spinner-border spinner-border-sm" role="status" *ngIf="loading.save"></div>
                    <span *ngIf="!loading.save">Atualizar</span>
                </button>
            </div>
        </form>
    </div>
</div>